export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const maybeError = error as { status?: unknown; originalStatus?: unknown };

  if (typeof maybeError.status === 'number') {
    return maybeError.status;
  }

  if (typeof maybeError.originalStatus === 'number') {
    return maybeError.originalStatus;
  }

  return undefined;
};

export const isNotFoundApiError = (error: unknown): boolean =>
  getApiErrorStatus(error) === 404;
